import { api } from '../../convex/_generated/api';
import { useConvexAuth, useQuery } from 'convex/react';

export const useGetPlanInfo = () => {
  const authConvex = useConvexAuth();
  const planInfo = useQuery(api.cloud_vods.getPlanInfo, authConvex.isAuthenticated ? undefined : 'skip');

  return {
    used: planInfo?.gbConsumed,
    limit: planInfo?.gbLimit,
    isLoading: planInfo === undefined,
    isSubscribed: planInfo?.isSubscribed,
  };
};
